// import {
//     Env
// } from './env.js';
export class ResizeElem {
  constructor() {
    this.toggleMenus = {};
  }

  getStyle(e, styleName) {
    var styleValue = "";
    if (document.defaultView && document.defaultView.getComputedStyle) {
      styleValue = document.defaultView.getComputedStyle(e, "").getPropertyValue(styleName);
    } else if (e.currentStyle) {
      styleName = styleName.replace(/\-(\w)/g, function (strMatch, p1) {
        return p1.toUpperCase();
      });
      styleValue = e.currentStyle[styleName];
    }
    return styleValue.replace(/px/g, "");
  }

  setProps(el, props) {
    for (let key in props) {
      el.style.setProperty("--" + key, props[key]);
    }
  }

  init() {
    // 環境
    //this.env = new Env();
    //this.env.detectEnv();
  }

  resizing() {
    let nowWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    let nowHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    this.body = document.getElementsByTagName("body")[0];
    let windowSizeChanged = false;

    //ウインドウサイズが変わった場合のみ実行したい
    if (this.body.classList.contains("os-ios") || this.body.classList.contains("os-android")) {
      //モバイルは幅のみで判定、高さはスクロール時にURLバーの大きさが変わる
      if (this.windowWidth !== nowWidth) {
        windowSizeChanged = true;
        console.log("window size changed mobile");
      }
    } else {
      //PC高さも
      if (this.windowWidth !== nowWidth || this.windowWeight !== nowHeight) {
        windowSizeChanged = true;
        console.log("window size changed PC");
      }
    }

    //ウインドウサイズが変わった場合のみ実行
    if (windowSizeChanged) {
      this.windowWidth = nowWidth;
      this.windowWeight = nowHeight;
    }

    //常に実行
    if (document.querySelectorAll(".swiper--index-cover")[0]) {
      let covers = document.querySelectorAll(".swiper--index-cover .slide-img");
      [].forEach.call(covers, (elem) => {
        // const imgWidth = elem.querySelector("img").naturalWidth;
        // const imgHeight = elem.querySelector("img").naturalHeight;
        // console.log(imgWidth, imgHeight);

        //imgRatioが1以上なら横長
        //const imgRatio = imgWidth / imgHeight;

        const imgBreakPoint = 900;
        let imgMode = "zoom";
        const windowRatio = nowWidth / nowHeight;

        // 画像サイズcommon
        let imgRatio = 1200 / 1700;
        if (nowWidth >= 900) {
          imgRatio = 2560 / 1700;
        }

        if (elem.classList.contains("slide-img--1") && nowWidth >= imgBreakPoint) {
          //上下スクロールあり
          imgMode = "motion-vertical";
          imgRatio = 1800 / 2560;
        }
        if (elem.classList.contains("slide-img--2") && nowWidth >= imgBreakPoint) {
          //上下スクロールあり
          imgMode = "motion-vertical";
          imgRatio = 1800 / 2560;
        }
        if (elem.classList.contains("slide-img--4") && nowWidth >= imgBreakPoint) {
          //左右スクロールあり
          imgMode = "motion-horisontal";
          imgRatio = 3000 / 1700;
        }
        elem.classList.add(imgMode);

        let msg = "";
        if (windowRatio > imgRatio) {
          msg = "ウインドウが画像より横長";
          elem.classList.add("overflow-top");
          elem.classList.remove("overflow-side");
        } else {
          msg = "ウインドウが画像より縦長";
          elem.classList.add("overflow-side");
          elem.classList.remove("overflow-top");
        }
        //console.log(elem.classList, imgRatio, windowRatio, msg);

        // if (elem.classList.contains("slide-img--0")) {
        //   //sp:zoom
        //   if (imgRatio > 1) {

        //   }
        //   //pc:zoom
        //   if (nowWidth >= 700) {
        //     if (imgRatio > 1) {
        //     }
        //   }
        // } else if (elem.classList.contains("slide-img--1")) {
        //   //sp:zoom, pc:down
        //   if (nowWidth >= 700) {
        //   }
        // } else if (elem.classList.contains("slide-img--2")) {
        //   //sp:zoom, pc:up
        //   if (nowWidth >= 700) {
        //   }
        // } else if (elem.classList.contains("slide-img--3")) {
        //   //sp:zoom, pc:zoom
        //   if (nowWidth >= 700) {
        //   }
        // } else if (elem.classList.contains("slide-img--4")) {
        //   //sp:zoom, pc:right
        //   if (nowWidth >= 700) {
        //   }
        // } else if (elem.classList.contains("slide-img--5")) {
        //   //sp:zoom, pc:zoom
        //   if (nowWidth >= 700) {
        //   }
        // } else if (elem.classList.contains("slide-img--6")) {
        //   //sp:zoom, pc:zoom
        //   if (nowWidth >= 700) {
        //   }
        // } else if (elem.classList.contains("slide-img--7")) {
        //   //sp:zoom, pc:zoom
        //   if (nowWidth >= 700) {
        //   }
        // }
      });
    }

    // let windowWidth = (window.innerWidth || document.documentElement.clientWidth || 0);
    // let windowHeight = (window.innerHeight || document.documentElement.clientHeight || 0);
    // let elemVideoHeight = 0;
    // let elemVideo = document.getElementById('video-inner');
    // let elemBtn = document.getElementById('btn-skip');
    // if (document.getElementById('btn-skip')) {
    //     if (windowWidth > 800) {
    //         elemVideoHeight = windowWidth * 0.65;
    //     } else {
    //         elemVideoHeight = windowWidth * 1.78;
    //     }
    //     //console.log(elemVideoHeight);
    // }
    // if (elemVideoHeight > windowHeight) {
    //     //console.log('out');
    //     let pos = 0.5 * (elemVideoHeight - windowHeight) + 20;
    //     elemBtn.style.bottom = pos + 'px';
    // }
  }
}
